export const configurationRequest = [{
  identifier: true,
  value: true
}, {}, {}];
